// shared/src/schemas/macro-prediction-drift-daily.ts
// Zod schema for `macro_prediction_drift_daily` table — V2 narrow shape
// per migration 0018_wipe_and_reshape.sql:316-324.
//
// The Phase 6 §K wipe simplified the per-observable daily drift row to
// just (close_value, drift_pct); the V1 fields (actual_value /
// actual_change_pct_from_baseline / drift_from_predicted_change_pct /
// in_ci_at_this_point / days_elapsed) were dropped at the reshape.
//
// 5 columns: id, observable_id, date, close_value, drift_pct.

import { z } from 'zod';

export const MacroPredictionDriftDailySchema = z.object({
  id:              z.string(),
  observable_id:   z.string(),
  date:            z.string(),                                          // ISO date 'YYYY-MM-DD'
  close_value:     z.number(),
  drift_pct:       z.number(),
});

export type MacroPredictionDriftDaily = z.infer<typeof MacroPredictionDriftDailySchema>;
